export default {
  call: {
    // 获取用户信息
    userInfo: { event_name: 'Storage.userInfo', message: {} },
    // 跳转登录页
    presentLoginController: {
      event_name: 'NativeController.presentLoginController',
      message: {},
    },
    // 修改原生导航
    refreshNav: {
      event_name: 'Controller.refreshNav',
      message: {
        title: '', // webview当前的title
        right: [{ img: '', func: 'pushShare' }],
        left: [{ img: '', func: '' }],
        fullScreen: false, // 是否隐藏状态栏和导航栏
        hiddenNav: false, // 是否隐藏导航栏
      },
    },
    // 点击导航栏返回按钮关闭webview
    close: { event_name: 'Controller.close', message: {} },
    // 系统分享
    presentSystemShare: {
      event_name: 'NativeController.presentSystemShare',
      message: {
        url: '',
      },
    },
    // 分享时传参
    presentShare: {
      event_name: 'NativeController.presentShare',
      message: {
        title: '',
        url: '',
        description: '',
        img: '',
        activityId: '',
        official: '', // 是否官方判断是否显示举报按钮
      },
    },
    // 调用原生webview打开链接
    pushViewController: {
      event_name: 'Controller.pushViewController',
      message: {
        vcType: '', // 对应本地的控制器
        page: '',
        shareInfo: {
          title: '',
          url: '',
          description: '',
          img: '',
          activityId: '',
          official: '', // 是否官方
        },
      },
    },
    // 图片预览
    previewImage: {
      event_name: 'NativeController.previewImage',
      message: {
        x: '',
        y: '',
        width: '',
        height: '',
        left: '', // 距离屏幕左上角的水平距离getBoundingClientRect().left
        top: '', // 距离屏幕左上角的垂直距离getBoundingClientRect().top
        src: '',
      },
    },
    // 存储视频到本地
    saveVideoToNative: {
      event_name: 'Controller.saveVideoToNative',
      message: { url: '', index: 1 },
    },
    // 取消下载
    cancelDownload: {
      event_name: 'Controller.cancelDownload',
      message: { url: '' },
    },
    // 获取本地信息
    getSysInfo: {
      event_name: 'Controller.getSysInfo',
      message: {},
    },
    // 获取网络状态
    getNetworkState: {
      event_name: 'Controller.getNetworkState',
      message: {},
    },
    // 告诉native是否要添加返回拦截
    isBackIntercept: {
      event_name: 'Controller.isBackIntercept',
      message: {},
    },
    // 调起google导航
    invokeGoogleMapNavigate: {
      event_name: 'Controller.invokeGoogleMapNavigate',
      message: {
        endPoint: '',
      },
    },
    // 定位
    locationInfo: {
      event_name: 'Controller.locationInfo',
      message: {},
    },
    // 上传图片
    uploadImg: {
      event_name: 'Controller.uploadImg',
      message: {},
    },
    // 判断是否安装谷歌地图
    hasGoogleMap: {
      event_name: 'Controller.hasGoogleMap',
      message: {},
    },
    // 判断是否安装Waze地图
    hasWazeMap: {
      event_name: 'Controller.hasWazeMap',
      message: {},
    },
    // 判断是否安装苹果地图
    hasAppleMap: {
      event_name: 'Controller.hasAppleMap',
      message: {},
    },
    // token失效的处理
    invalidToken: {
      event_name: 'Controller.invalidToken',
      message: {},
    },
    // 返回首页
    backHomePage: {
      event_name: 'Controller.backHomePage',
      message: {},
    },
    // 跳转native统一方法
    jumpToNative: {
      event_name: 'Controller.jumpToNative',
      message: {},
    },
    /**
         * iOS下提供方法
         * 调用全屏右滑返回或禁止-一般H5带地图的界面需要禁用全屏返回。
            pop出的新界面如果无地图可不设定。
            设定后在网页内部跳转需要重新设定。
            enableFullScreenBack
            参数: enable: 布尔值，开启或禁止，必传；
            返回值： 无;
        */
    enableFullScreenBack: {
      event_name: 'Controller.enableFullScreenBack',
      message: {},
    },
    // 获取埋点信息
    getTrackInfo: { event_name: 'Controller.getTrackInfo', message: {} },
    // IOS上下滑动(影响全部)
    closeSlideUpAndDown: {
      event_name: 'Controller.closeSlideUpAndDown',
      message: { close: false }, // 参数：布尔值，是否关闭，默认fasle
    },
    // IOS上下滑动(影响原生导航)
    closeBounces: {
      event_name: 'Controller.closeBounces',
      message: { close: false }, // 参数：布尔值，是否关闭，默认fasle
    },
    needUpdateVersion: {
      event_name: 'Controller.needUpdateVersion',
      message: {},
    },
    // 调起Apple导航
    invokeAppleMapNavigate: {
      event_name: 'Controller.invokeAppleMapNavigate',
      message: {
        endPoint: '',
        endAddress: '',
      },
    },
    // 神策埋点
    buriedPoint: {
      event_name: 'Controller.buriedPoint',
      message: {},
    },
    // 调起原生分享弹框
    presentSharePage: {
      event_name: 'NativeController.presentSharePage',
      message: {
        platforms: ['facebook', 'copylink', 'more'],
      },
    },
    // 提示对话框
    showTipsDialog: {
      event_name: 'NativeController.showTipsDialog',
      message: {
        message: '',
        negativeButtonText: null, // 去掉默认空串
        positiveButtonText: '',
        callBack: () => {}, // 必传
      },
    },
    // 原生toast
    showToast: {
      event_name: 'NativeController.showToast',
      message: {
        message: '',
        iconBase64: '',
      },
    },
    // 复制
    copy: {
      event_name: 'Controller.copy',
      message: {},
    },
    // 调起Waze导航
    invokeWazeMapNavigate: {
      event_name: 'Controller.invokeWazeMapNavigate',
      message: {
        endPoint: '',
      },
    },
    // 刷新Token
    refreshToken: {
      event_name: 'Controller.refreshToken',
      message: {},
    },
    // 查询全局配置
    querySwitchConfig: {
      event_name: 'Controller.querySwitchConfig',
      message: {},
    },
    // 隐私协议撤销
    recallProtocol: {
      event_name: 'Controller.recallProtocol',
      message: {},
    },
    // android打开pdf文件
    checkFileExist: {
      event_name: 'Controller.checkFileExist',
      message: {},
    },
    // 车联服务激活和关闭
    clickTServiceAgreement: {
      event_name: 'NativeController.clickTServiceAgreement',
      message: {},
    },
  },
  register: {
    nativeLoginSuccess: 'nativeLoginSuccess', // 本地登录成功后调用
    backIntercept: 'backIntercept',
    enterWebview: 'enterWebview', // 原生返回拦截
    deleteAddress: 'deleteAddress', // 调用删除地址方法
    gotoShopCar: 'gotoShopCar', // 支付成功页关闭跳转购物车页面
    nativeLogout: 'nativeLogout', // 登出调用
    refreshWebViewData: 'refreshWebViewData', // 刷新H5
    nativePostSuccessNotification: 'nativePostSuccessNotification', // 同步用户名片关注的状态
    pushShare: 'pushShare', // 分享
    receiveResult: 'receiveResult', // 接收webview数据
    leaveWebview: 'leaveWebview',
  },
}
